jQuery(function($) {

    function resetLvl2State() {
        $('.lvl-2-link-container').each(function() {
            $(this).find('.lvl-2-with-children-link').removeClass('inactive');
            $(this).find('.lvl-3-link-container-wrapper').hide();
            $(this).find('.menu-item-tag').show();
        });
    }

    var swiperMobileTopNav = new Swiper('.mm-menu-top-nav', {
        slidesPerView: 3,
        spaceBetween: 4,
        centeredSlides: false,
        slidesOffsetAfter: 50
    });

    var swiperMobileMenuPanels = new Swiper('.mm-menu-panels', {
        slidesPerView: 1,
        spaceBetween: 4,
        centeredSlides: false,
        slidesOffsetAfter: 50,
        allowTouchMove: false,
        on: {
            slideChange: function() {
                swiperMobileTopNav.slideTo(swiperMobileMenuPanels.activeIndex);
                $('.mm-menu-item').removeClass('active');
                $('.mm-menu-item[data-index="' + (swiperMobileMenuPanels.activeIndex + 1) + '"]').addClass('active');
            }
        }
    });

    $('.mm-menu-item').first().addClass('active');

    $('.mm-menu-top-nav').on('click', '.mm-menu-item', function() {
        $('.mm-menu-item').removeClass('active');
        $(this).addClass('active');
        swiperMobileTopNav.slideTo($(this).data('index') - 1);
        swiperMobileMenuPanels.slideTo($(this).data('index') - 1);
        resetLvl2State();
    });
       
    $('.lvl-2-link-container').each(function() {
        $lvl2Container = $(this);
        $lvl3Container = $(this).find('.lvl-3-link-container-wrapper');

        $lvl3Container.hide();

        $lvl2Container.find('.lvl-2-with-children-link').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            $lvl3Container.show();
            $lvl2Container.find('.lvl-2-with-children-link').addClass('inactive');
            $lvl2Container.find('.menu-item-tag').hide();
            $(this).removeClass('inactive');
            $index = $(this).data('index');
            
            $lvl3Container.find('.lvl-3-link-inner').hide();
            $lvl3Container.find('.lvl-3-link-inner[data-index="' + $index + '"]').show();

        });
    });

  });

  jQuery(function($){
    $('.mnav-inner-first.lvl-1-item > a:not(.dead-end)').on('click', function(e){
      e.preventDefault()
      e.stopPropagation()
      return false;
    })
    $('.lvl-2-item.lvl-2-with-children > a:not(.dead-end)').on('click', function(e){
        e.preventDefault()
        e.stopPropagation()       
        $('.mnav-subpage').hide();
        $target = $('.mnav-subpage').eq($(this).data('for') - 1);
        $target.show();
        $target.animate({left: '0'}, 300);
        return false;
    });
    $('.mnav-subpage .lvl-1-item.lvl-1-item-first > a:not(.dead-end)').on('click', function(e){
        e.preventDefault()
        e.stopPropagation()
        $target = $('.mnav-subpage');
        
        $target.animate({left: '100%'}, 300, function(){
            // $target.hide();
        });
        return false;
    });
  })

  jQuery(function ($) {
    $('.marquee-wrapper').marquee({
        duration:30000,
        gap: 0,
        duplicated: true,
        duplicateCount: 4,
        startVisible: true
    });
});

window.addEventListener('load', () => {
    document.querySelector('.facets__button-show')?.click()
});

// hotfix for inveterate to use rebuy cart
jQuery(function($) {
    $('input[value="41716122583115"]').each(function() {
        $(this).after('<input type="hidden" name="selling_plan" value="1076002891" />');
        $(this).after('<input type="hidden" name="properties[_inveterate_subscription]" value="true" />');
    })
});
